<div class="tecGym-component">
    <p-dialog [(visible)]="pettylendingdialogVisibility" [header]='setLabel("pettyLendingExpenseLabel")'
        (onHide)="closePettyLendingDialogBefore()">
        <div class="payout-main-wrapper">
            <div class="payout-main-wrapper">
                <p-table [value]="pettyExpenses" [loading]="loading" [style]="{width: '70rem'}"
                    class="p-table-tecfolk-fix">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>{{setLabel("amountLabel")}}</th>
                            <th>{{setLabel("expenseTypeLabel")}}</th>
                            <th>{{setLabel("detailsLabel")}}</th>
                            <th>{{setLabel("createdOnLabel")}}</th>
                            <th>{{setLabel("commentLabel")}}</th>
                            <th>{{setLabel("actionLabel")}}</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-pe>
                        <tr>
                            <td>{{pe.amount}}</td>
                            <td>{{pe.type}}</td>
                            <td>{{getDetailOfExpance(pe)}}</td>
                            <td>{{pe.createdDate | date:'dd/MM/yyyy'}}</td>
                            <td>{{pe.description}}</td>
                            <td><button class="p-button-success" pButton (click)="updatePettyExpense(pe._id)">
                                    <label>{{setLabel("amountReturnedLabel")}}</label>
                                </button></td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </p-dialog>
</div>